export const isAllowUploadFile = (extensions: string[], file: File) => {
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  return fileExtension ? extensions.some((ext) => ext.toLowerCase() === fileExtension) : false;
};

export const isFileSizeValid = (file: File, maxSize: number) => {
  return file.size <= maxSize;
};
